import { FC } from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import { NewsForms, fetchNewsRecord, fetchNewsUpdate, INews } from '../../../../features/news';
import { useEntityUpdate } from '../../../../features/entities/hooks';
import { PreloaderWrapper } from '../../../../components/preloader-wrapper';
import { PageTitle } from '../../../../components/page-title';
import { CabinetContainer } from '../../../../components/cabinet-container';
import { ROUTE_NEWS } from '../../../../common/constants';
import { get } from '../../../../common/utils';

export const NewsUpdatePage: FC = () => {
  const { t } = useTranslation();
  const { isFetching, isUpdating, data, handleValid } = useEntityUpdate<INews>({
    entity: 'news',
    recordThunk: fetchNewsRecord,
    updateThunk: fetchNewsUpdate,
    nextPath: ROUTE_NEWS,
  });

  const defaultValues = { ...data };

  return (
    <>
      <Helmet>
        <title>{t('news.update')}</title>
      </Helmet>
      <CabinetContainer>
        <PageTitle title={t('news.update.title')} mb={3} />
        <PreloaderWrapper isLoading={isFetching}>
          <NewsForms
            onValid={handleValid}
            defaultValues={defaultValues}
            isLoading={isUpdating}
            key={get(data, 'id')}
          />
        </PreloaderWrapper>
      </CabinetContainer>
    </>
  );
};
